<!-- IPO 活动页内容区：奖品图 + 任务区域 -->
<script lang="ts">
  import TaskSection from "./TaskSection.svelte";

  let {
    imageSrc = null,
    openAccountDisabled = false,
    depositDisabled = false,
    tradeDisabled = false,
    ipoDisabled = false,
    onOpenAccount = undefined,
    onDeposit = undefined,
    onTrade = undefined,
    onIpo = undefined,
    onMoreRewards = undefined,
  }: {
    imageSrc: string | null;
    /** 去开户按钮是否禁用 */
    openAccountDisabled?: boolean;
    /** 去入金按钮是否禁用 */
    depositDisabled?: boolean;
    /** 去交易按钮是否禁用 */
    tradeDisabled?: boolean;
    /** 去认购按钮是否禁用 */
    ipoDisabled?: boolean;
    onOpenAccount?: () => void;
    onDeposit?: () => void;
    onTrade?: () => void;
    onIpo?: () => void;
    onMoreRewards?: () => void;
  } = $props();
</script>

<div class="flex w-full flex-col items-center mb-4">
  {#if imageSrc}
    <img
      class="mb-[12px] h-auto w-full rounded-[12px]"
      src={imageSrc}
      alt="ipo activity content"
    />
  {/if}
</div>

<TaskSection
  {openAccountDisabled}
  {depositDisabled}
  {tradeDisabled}
  {ipoDisabled}
  {onOpenAccount}
  {onDeposit}
  {onTrade}
  {onIpo}
  {onMoreRewards}
/>
